module.exports = __webpack_public_path__ + "static/media/atd-icon.5a0cd3a5.svg";